import { AppModal } from 'shared/UI/UIKit/Modal';
import { BellScheduleForm } from 'entities/bell-schedule/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import type { BellSchedule } from 'services/api';
import { useBellScheduleEdit } from '../model';
import styles from './styles.module.scss';

interface BellScheduleEditProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const BellScheduleEdit = ({ bellSchedule, refreshTable }: BellScheduleEditProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useBellScheduleEdit({ bellSchedule, refreshTable });

  return (
    <>
      <AppEditIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<BellScheduleForm form={form} />}
        title="Редактирование расписания"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Сохранить
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
